module.exports = __webpack_public_path__ + "assets/bold.5d21b42f.svg";